export class PageNumber {
    number: number;
    selected: boolean = false;
}
